const ADS_KINDS = new Set([
  "facebook_ads_account",
  "google_ads_customer",
  "linkedin_ads_account",
  "tiktok_ads_account",
]);

function accountKind(account) {
  return account?.connectedAccount?.providerAccountKind || account?.providerAccountKind || "";
}

function accountProvider(account) {
  return account?.connectedAccount?.provider || account?.provider || "";
}

/**
 * Series keys to try, in order, for one trend tab on this account.
 * An empty list means the tab does not apply to the source.
 */
export function trendSeriesKeys(account, tab) {
  const kind = accountKind(account);
  const provider = accountProvider(account);

  if (kind === "ga4_property" || (provider === "google" && kind !== "google_ads_customer")) {
    if (tab === "reach") return ["users"];
    if (tab === "impressions") return ["pageViews"];
    if (tab === "engagements") return ["engagedSessions", "engagements"];
    return [];
  }

  if (kind === "search_console_site" || provider === "search_console") {
    if (tab === "reach") return ["clicks"];
    if (tab === "impressions") return ["impressions"];
    return [];
  }

  if (kind === "instagram_business") {
    if (tab === "reach") return ["reach"];
    if (tab === "impressions") return ["views", "impressions"];
    if (tab === "engagements") return ["engagements"];
    if (tab === "followers") return ["followers"];
    return [];
  }

  if (ADS_KINDS.has(kind)) {
    if (tab === "reach") return ["reach", "impressions"];
    if (tab === "impressions") return ["impressions"];
    return [];
  }

  if (tab === "reach") return ["reach"];
  if (tab === "impressions") return ["impressions", "views"];
  if (tab === "engagements") return ["engagements"];
  if (tab === "followers") return ["followers"];
  return [];
}

export function trendTabsForAccount(account) {
  const kind = accountKind(account);
  const impressionsLabel = kind === "instagram_business" ? "Views" : "Impressions";
  return [
    { key: "reach", label: "Reach" },
    { key: "impressions", label: impressionsLabel },
    { key: "engagements", label: "Engagements" },
    { key: "followers", label: "Followers" },
  ].filter((tab) => trendSeriesKeys(account, tab.key).length > 0);
}

export function seriesHasDates(points) {
  return Array.isArray(points) && points.some((point) => point?.date);
}

export function pickTrendSeries(seriesData, keys) {
  for (const key of keys || []) {
    const points = seriesData?.[key];
    if (seriesHasDates(points)) return points;
  }
  return null;
}

export function accountHasTrendRows(seriesData) {
  return Object.values(seriesData || {}).some((points) => seriesHasDates(points));
}
